import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import Header from '../../layouts/Header';
import axiosInstance from '../../api/axios';import { Button, Card, Table, Badge, Spinner, Modal, Form, InputGroup, Pagination, Dropdown, Row, Col, Accordion, Tab, Nav } from 'react-bootstrap';
import { ArrowLeft, InfoCircle, Tag, Shop, Clock, CashCoin, Gift, Percent, ArrowUp, ArrowDown, Search, Filter, ThreeDots, Ban, CheckCircle, XCircle, Plus, ListCheck, CalendarCheck, ClockHistory, ShieldCheck, Receipt, Box, Layers, Image, Truck, Egg, AlertCircle, Star, Award, FileText, Users, MapPin, CreditCard, Calendar, BarChart, Box2 } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';

const ProductDetailReport = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();
    const { productId, productName, route } = useParams();
    console.log("Product Id Coming From Params :", productId);
    console.log("Route Coming From Params :", route);


    const accessToken = localStorage.getItem("authToken");
    const [productsList, setProductsList] = useState([]);
    const [productDetailData, setProductDetailData] = useState({});
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [loading, setLoading] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);

    // Coupons filtering and pagination
    const [couponSearch, setCouponSearch] = useState('');
    const [couponFilter, setCouponFilter] = useState('ALL');
    const [currentCouponPage, setCurrentCouponPage] = useState(1);
    const couponsPerPage = 10;

    // Addons modal
    const [showAllAddons, setShowAllAddons] = useState(false);
    const [showAddonDetails, setShowAddonDetails] = useState(false);
    const [selectedAddon, setSelectedAddon] = useState(null);

    // Subscriptions modal
    const [showAllSubscriptions, setShowAllSubscriptions] = useState(false);

    // Advertisement details modal
    const [showAdDetails, setShowAdDetails] = useState(false);
    const [selectedAd, setSelectedAd] = useState(null);

    // Raw Materials details modal
    const [showRawMaterials, setShowRawMaterials] = useState(false);

    const animatedComponents = makeAnimated();

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minHeight: "45px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
            backgroundColor: skin === "dark" ? "#2b2b2b" : "white",
            color: skin === "dark" ? "white" : "black",
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: skin === "dark" ? "#2b2b2b" : "white",
            color: skin === "dark" ? "white" : "black",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
                ? (skin === "dark" ? "#404040" : "#e9ecef")
                : (skin === "dark" ? "#2b2b2b" : "white"),
            color: skin === "dark" ? "white" : "black",
            "&:hover": {
                backgroundColor: skin === "dark" ? "#404040" : "#e9ecef",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: skin === "dark" ? "white" : "black",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
        input: (provided) => ({
            ...provided,
            color: skin === "dark" ? "white" : "black",
        }),
    };

    const getProductsList = async () => {
        setLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) {
                const products = response?.data?.data?.products || [];
                const formattedProducts = products.map(product => ({
                    value: product._id,
                    label: product.name,
                    data: product
                }));
                setProductsList(formattedProducts);
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getProductDetailReport(productId);
    }, [productId]);

    const getProductDetailReport = async (productId) => {
        if (!productId) return;

        setReportLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get(`product/getProductDetails?productId=${productId}`, { headers });
            console.log("Response of That Product :", response?.data?.data);

            if (response?.data?.status === true) {
                setProductDetailData(response?.data?.data || {});
                setCouponSearch('');
                setCouponFilter('ALL');
                setCurrentCouponPage(1);
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setReportLoading(false);
        }
    };

    const handleProductSelect = (selectedOption) => {
        setSelectedProduct(selectedOption);
        if (selectedOption) {
            getProductDetailReport(selectedOption.value);
        } else {
            setProductDetailData({});
        }
    };

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
            errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 412) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
            errorMessage = error.response?.data?.error;
        }

        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 3
        }).format(price);
    };

    const getProductStatusBadge = (status) => {
        const statusConfig = {
            "ACTIVE": { variant: "success", text: "Active" },
            "INACTIVE": { variant: "secondary", text: "Inactive" },
            "DRAFT": { variant: "warning", text: "Draft" }
        };

        const config = statusConfig[status] || { variant: "secondary", text: status };
        return <Badge bg={config.variant}>{config.text}</Badge>;
    };

    const getFoodTypeBadge = (type) => {
        const typeConfig = {
            "VEG": { variant: "success", text: "Veg" },
            "NON_VEG": { variant: "danger", text: "Non-Veg" },
            "EGG": { variant: "warning", text: "Egg" }
        };

        const config = typeConfig[type] || { variant: "secondary", text: type };
        return <Badge bg={config.variant}>{config.text}</Badge>;
    };

    const getOutletStatusBadge = (status) => {
        const statusConfig = {
            "IN_STOCK": { variant: "success", text: "In Stock" },
            "OUT_OF_STOCK": { variant: "danger", text: "Out of Stock" },
            "EXHAUSTED": { variant: "warning", text: "Exhausted" },
            "NOT_AVAILABLE": { variant: "secondary", text: "Not Available" }
        };

        const config = statusConfig[status] || { variant: "secondary", text: status };
        return <Badge bg={config.variant}>{config.text}</Badge>;
    };

    const getCouponTypeIcon = (coupon) => {
        if (coupon.isBogoCoupon) return <Gift className="text-warning" />;
        if (coupon.discountPercent) return <Percent className="text-success" />;
        if (coupon.discountAmount) return <CashCoin className="text-info" />;
        if (coupon.discountPrice) return <Tag className="text-primary" />;
        if (coupon.newSizeUpgradeAddon) return <ArrowUp className="text-secondary" />;
        if (coupon.isFreebieCoupon) return <Gift className="text-danger" />;
        return <InfoCircle className="text-muted" />;
    };

    const getCouponTypeText = (coupon) => {
        if (coupon.isBogoCoupon) return "BOGO";
        if (coupon.discountPercent) return `${coupon.discountPercent}% Off`;
        if (coupon.discountAmount) return `₹${coupon.discountAmount} Off`;
        if (coupon.discountPrice) return `₹${coupon.discountPrice}`;
        if (coupon.newSizeUpgradeAddon) return "Size Upgrade";
        if (coupon.isFreebieCoupon) return `Freebie`;
        return "Special Offer";
    };

    const getCouponStatus = (coupon) => {
        return coupon.status === "ACTIVE" ? (
            <Badge bg="success">Active</Badge>
        ) : (
            <Badge bg="secondary">Inactive</Badge>
        );
    };

    const getCouponTypeForFilter = (coupon) => {
        if (coupon.isBogoCoupon) return 'BOGO';
        if (coupon.discountPercent) return 'PERCENTAGE';
        if (coupon.discountAmount) return 'FIXED_AMOUNT';
        if (coupon.discountPrice) return 'FIXED_PRICE';
        if (coupon.newSizeUpgradeAddon) return 'SIZE_UPGRADE';
        if (coupon.isFreebieCoupon) return 'FREEBIE';
        return 'OTHER';
    };

    const getCouponTypeColor = (type) => {
        const colors = {
            'BOGO': 'warning',
            'PERCENTAGE': 'success',
            'FIXED_AMOUNT': 'info',
            'FIXED_PRICE': 'primary',
            'SIZE_UPGRADE': 'secondary',
            'FREEBIE': 'danger',
            'OTHER': 'light'
        };
        return colors[type] || colors.OTHER;
    };

    const getSubscriptionTypeBadge = (type) => {
        const typeConfig = {
            "HOURLY": { variant: "info", text: "Hourly" },
            "DAILY": { variant: "primary", text: "Daily" },
            "WEEKLY": { variant: "success", text: "Weekly" },
            "MONTHLY": { variant: "warning", text: "Monthly" }
        };
        const config = typeConfig[type] || { variant: "secondary", text: type };
        return <Badge bg={config.variant}>{config.text}</Badge>;
    };

    const getSubscriptionStatusBadge = (status) => {
        return status === "ACTIVE" ? (
            <Badge bg="success">Active</Badge>
        ) : (
            <Badge bg="secondary">Inactive</Badge>
        );
    };

    const handleViewAddonDetails = (addon) => {
        setSelectedAddon(addon);
        setShowAddonDetails(true);
    };

    const handleViewAdDetails = (ad) => {
        setSelectedAd(ad);
        setShowAdDetails(true);
    };

    useEffect(() => {
        // getProductsList();
    }, []);

    const product = productDetailData?.product || {};
    const category = product.category || {};
    const coupons = productDetailData?.applicableCoupons || [];
    const addons = productDetailData?.addonConfiguration?.addons || [];
    const eligibleSubscriptions = productDetailData?.eligibleSubscriptions || [];
    const outletAvailability = productDetailData?.outletAvailability || [];
    const menuGroupPricing = productDetailData?.menuGroupPricing || [];
    const outletConfiguration = productDetailData?.outletConfiguration || {};
    const excludedOutlets = outletConfiguration?.excludedOutlets || [];
    const addonConfiguration = productDetailData?.addonConfiguration || {};
    const productUpdateLogs = productDetailData?.productUpdateLogs || [];
    const advertisements = productDetailData?.advertisements || [];
    const inAppAdvertisements = productDetailData?.inAppAdvertisements || [];
    const rawMaterialAutoDeduction = productDetailData?.rawMaterialAutoDeduction || [];

    // Filter and search coupons
    const filteredCoupons = coupons.filter(coupon => {
        const searchMatch = couponSearch === '' ||
            coupon.title?.toLowerCase().includes(couponSearch.toLowerCase()) ||
            coupon.couponCode?.toLowerCase().includes(couponSearch.toLowerCase()) ||
            coupon.description?.toLowerCase().includes(couponSearch.toLowerCase());

        const typeMatch = couponFilter === 'ALL' ||
            getCouponTypeForFilter(coupon) === couponFilter ||
            (couponFilter === 'ACTIVE' && coupon.status === 'ACTIVE') ||
            (couponFilter === 'INACTIVE' && coupon.status !== 'ACTIVE');

        return searchMatch && typeMatch;
    });

    // Coupons pagination calculations
    const totalCouponPages = Math.ceil(filteredCoupons.length / couponsPerPage);
    const startCouponIndex = (currentCouponPage - 1) * couponsPerPage;
    const endCouponIndex = startCouponIndex + couponsPerPage;
    const currentCoupons = filteredCoupons?.slice(startCouponIndex, endCouponIndex);

    const handleCouponPageChange = (pageNumber) => {
        setCurrentCouponPage(pageNumber);
    };

    // Function to render pagination
    const renderPagination = (currentPage, totalPages, onPageChange) => {
        const items = [];
        const maxVisible = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);

        if (endPage - startPage + 1 < maxVisible) {
            startPage = Math.max(1, endPage - maxVisible + 1);
        }

        if (startPage > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => onPageChange(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" />);
            }
        }

        for (let number = startPage; number <= endPage; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => onPageChange(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" />);
            }
            items.push(
                <Pagination.Item key={totalPages} onClick={() => onPageChange(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }
        return items;
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                <div className="card shadow-sm border-0">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-0 fw-semibold d-inline-block">
                                <i className="bi bi-box-seam me-2"></i><span className='text-primary'>{productName?.toUpperCase()}</span>
                            </h4>
                        </div>
                        <div>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                // onClick={() => navigate('/menu/menu-catalog')}
                                onClick={() => {
                                    if (route === 'product-detail-report') {
                                        navigate('/masters/menu-pricing');
                                    } else {
                                        navigate('/menu/menu-catalog');
                                    }
                                }}
                                className="me-3 d-flex align-items-center fw-semibold"
                                style={{ height: '38px' }}
                            >
                                <ArrowLeft className="me-1" /> { route === 'product-detail-report' ? 'Back to Menu Pricing' : 'Back to Menu Catalog' } 
                            </Button>
                        </div>
                    </div>
                    <hr className='mt-0 mb-0' />

                    <div className="card-body">
                        {/* Product Selection */}
                        {/* <div className="row mb-4">
                            <div className="col-12">
                                <label className="form-label fw-semibold mb-2">
                                    <i className="bi bi-search me-2"></i>Select Product
                                </label>
                                <Select
                                    components={animatedComponents}
                                    options={productsList}
                                    styles={customStyles}
                                    placeholder="Search and select a product..."
                                    value={selectedProduct}
                                    onChange={handleProductSelect}
                                    isClearable
                                    isLoading={loading}
                                />
                                <div className="form-text mt-1">
                                    Select a product to view detailed information, pricing, coupons, and outlet availability.
                                </div>
                            </div>
                        </div> */}

                        {reportLoading ? (
                            <div className="text-center py-5">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Loading product details...</p>
                            </div>
                            // ) : selectedProduct ? (
                        ) : productDetailData ? (
                            <Tab.Container defaultActiveKey="product">
                                <Row>
                                    <Col lg={3} className="mb-4 mb-lg-0">
                                        <Card className="shadow-sm border-0 sticky-top" style={{ top: '20px', zIndex: 0 }}>
                                            <Card.Body className="p-0">
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="product">
                                                            <i className="bi bi-box me-2"></i>Product Info
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="category">
                                                            <i className="bi bi-layers me-2"></i>Category Details
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="pricing">
                                                            <i className="bi bi-currency-rupee me-2"></i>Pricing
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="addons">
                                                            <i className="bi bi-plus-circle me-2"></i>Addons
                                                            {addons.length > 0 && (
                                                                <Badge bg="success" className="ms-2">{addons.length}</Badge>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="coupons">
                                                            <i className="bi bi-tag me-2"></i>Coupons
                                                            {coupons.length > 0 && (
                                                                <Badge bg="success" className="ms-2">{coupons.length}</Badge>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="subscriptions">
                                                            <i className="bi bi-calendar-check me-2"></i>Subscriptions
                                                            {eligibleSubscriptions.length > 0 && (
                                                                <Badge bg="success" className="ms-2">{eligibleSubscriptions.length}</Badge>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="outlets">
                                                            <i className="bi bi-shop me-2"></i>Outlet Availability
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="advertisements">
                                                            <i className="bi bi-megaphone me-2"></i>Advertisements
                                                            {(advertisements.length > 0 || inAppAdvertisements.length > 0) && (
                                                                <Badge bg="success" className="ms-2">
                                                                    {advertisements.length + inAppAdvertisements.length}
                                                                </Badge>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="rawMaterials">
                                                            <i className="bi bi-boxes me-2"></i>Menu Ingredients
                                                            {rawMaterialAutoDeduction.length > 0 && (
                                                                <Badge bg="success" className="ms-2">{rawMaterialAutoDeduction.length}</Badge>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="updates">
                                                            <i className="bi bi-clock-history me-2"></i>Update History
                                                            {productUpdateLogs.length > 0 && (
                                                                <Badge bg="success" className="ms-2">{productUpdateLogs.length}</Badge>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col lg={9}>
                                        <Tab.Content>
                                            {/* Product Information Tab */}
                                            <Tab.Pane eventKey="product">
                                                <Card className="shadow-sm border-0 mb-4" style={{ fontSize: "13px" }}>

                                                    {/* Header */}
                                                    <Card.Header
                                                        className="bg-light border-0"
                                                        style={{ padding: "10px 16px", fontSize: "14px" }}
                                                    >
                                                        <h6 className="mb-0 fw-bold">
                                                            <i className="bi bi-box me-2"></i>
                                                            Product Information
                                                        </h6>
                                                    </Card.Header>

                                                    {/* Body */}
                                                    <Card.Body style={{ padding: "16px" }}>
                                                        <Row className="d-flex gap-1">

                                                            {/* Images Section */}
                                                            <Col md="3">
                                                                <Row>
                                                                    {/* Display Image */}
                                                                    <Col md={8}>
                                                                        {product.displayImage && (
                                                                            <div style={{ position: "relative", marginBottom: "10px" }}>

                                                                                {/* NEW Badge */}
                                                                                {product?.isNewProduct && (
                                                                                    <span
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            top: "6px",
                                                                                            left: "140px",
                                                                                            backgroundColor: "#28a745",
                                                                                            color: "#fff",
                                                                                            padding: "2px 8px",
                                                                                            fontSize: "10px",
                                                                                            fontWeight: "600",
                                                                                            borderRadius: "10px"
                                                                                        }}
                                                                                    >
                                                                                        NEW
                                                                                    </span>
                                                                                )}

                                                                                <img
                                                                                    src={product.displayImage}
                                                                                    alt={product.name}
                                                                                    style={{
                                                                                        width: "160px",
                                                                                        height: "160px",
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "6px",
                                                                                        border: "1px solid #eee"
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </Col>

                                                                    {/* Cover Picture */}
                                                                    <Col md={8}>
                                                                        {product.coverPicture && (
                                                                            <img
                                                                                src={product.coverPicture}
                                                                                alt="cover"
                                                                                style={{
                                                                                    width: "160px",
                                                                                    height: "160px",
                                                                                    objectFit: "cover",
                                                                                    borderRadius: "6px",
                                                                                    border: "1px solid #eee"
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </Col>

                                                                </Row>
                                                            </Col>

                                                            {/* Product Details */}
                                                            <Col style={{ flex: 1 }}>

                                                                {/* Title and Price */}
                                                                <div className="d-flex justify-content-between mb-2">

                                                                    <div>

                                                                        <div
                                                                            style={{
                                                                                fontSize: "16px",
                                                                                fontWeight: "600",
                                                                                marginBottom: "4px"
                                                                            }}
                                                                        >
                                                                            {product.name}
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                color: "#6c757d",
                                                                                fontSize: "12px",
                                                                                marginBottom: "8px"
                                                                            }}
                                                                        >
                                                                            {product.description}
                                                                        </div>

                                                                        {/* Badges */}
                                                                        <div className="d-flex flex-wrap gap-2">

                                                                            <div>
                                                                                <span style={{ color: "#6c757d", fontSize: "12px" }}>
                                                                                    Status:
                                                                                </span>{" "}
                                                                                {getProductStatusBadge(product.status)}
                                                                            </div>

                                                                            <div>
                                                                                <span style={{ color: "#6c757d", fontSize: "12px" }}>
                                                                                    Type:
                                                                                </span>{" "}
                                                                                {getFoodTypeBadge(product.foodType)}
                                                                            </div>

                                                                            <div>
                                                                                <span style={{ color: "#6c757d", fontSize: "12px" }}>
                                                                                    Class:
                                                                                </span>{" "}
                                                                                <Badge
                                                                                    bg="info"
                                                                                    style={{ fontSize: "10px", padding: "3px 6px" }}
                                                                                >
                                                                                    {product.classType}
                                                                                </Badge>
                                                                            </div>

                                                                            <div>
                                                                                <span style={{ color: "#6c757d", fontSize: "12px" }}>
                                                                                    Promoted:
                                                                                </span>{" "}
                                                                                {productDetailData.isPromoted ? (
                                                                                    <Badge
                                                                                        bg="warning"
                                                                                        style={{ fontSize: "10px", padding: "3px 6px" }}
                                                                                    >
                                                                                        Yes
                                                                                    </Badge>
                                                                                ) : (
                                                                                    <Badge
                                                                                        bg="secondary"
                                                                                        style={{ fontSize: "10px", padding: "3px 6px" }}
                                                                                    >
                                                                                        No
                                                                                    </Badge>
                                                                                )}
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* Price */}
                                                                    <div style={{ textAlign: "right" }}>

                                                                        <div>
                                                                            <span style={{ fontSize: "12px", color: "#6c757d" }}>
                                                                                Offer Price
                                                                            </span>
                                                                            <div style={{ fontWeight: "600", fontSize: "14px" }}>
                                                                                {formatPrice(product.offerPrice || 0)}
                                                                            </div>
                                                                        </div>

                                                                        <div style={{ fontSize: "12px", color: "#6c757d" }}>
                                                                            MRP: {formatPrice(product.mrp || 0)}
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                {/* Metadata Grid */}
                                                                <div className="row mt-3">

                                                                    <div className="col-md-3">
                                                                        <div style={{ marginBottom: "8px" }}>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                Making Time
                                                                            </div>
                                                                            <div style={{ fontWeight: "500" }}>
                                                                                <Clock size={14} /> {product.makingTime || 0} mins
                                                                            </div>
                                                                        </div>

                                                                        <div>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                Calories
                                                                            </div>
                                                                            <div style={{ fontWeight: "500" }}>
                                                                                {product.calories || 0} kcal
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div style={{ marginBottom: "8px" }}>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                Weight
                                                                            </div>
                                                                            <div style={{ fontWeight: "500" }}>
                                                                                <Box2 size={14} /> {product.weight || 0} {product.weightUnit}
                                                                            </div>
                                                                        </div>

                                                                        <div>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                Tax
                                                                            </div>
                                                                            <div style={{ fontWeight: "500" }}>
                                                                                <Receipt size={14} /> {product.taxPercent || 0}%
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div style={{ marginBottom: "8px" }}>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                Sequence
                                                                            </div>
                                                                            <div style={{ fontWeight: "500" }}>
                                                                                {product.sequenceNumber || 0}
                                                                            </div>
                                                                        </div>

                                                                        <div>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                HSN Code
                                                                            </div>
                                                                            <code style={{ fontSize: "11px" }}>
                                                                                {product.hsn || "N/A"}
                                                                            </code>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div style={{ marginBottom: "8px" }}>
                                                                            <div style={{ fontSize: "11px", color: "#6c757d" }}>
                                                                                Order Type
                                                                            </div>
                                                                            <div style={{ fontWeight: "500" }}>
                                                                                <Truck size={14} /> {product.orderType}
                                                                            </div>
                                                                        </div>

                                                                        {product.hasAddon && (
                                                                            <div style={{ fontSize: "12px", color: "#198754", fontWeight: "500" }}>
                                                                                <Plus size={14} /> Has Addons
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                </div>

                                                                {/* Product Nature */}
                                                                {product.productsNature?.length > 0 && (
                                                                    <div style={{ marginTop: "12px" }}>
                                                                        <div style={{ fontSize: "12px", color: "#6c757d" }}>
                                                                            Product Nature
                                                                        </div>
                                                                        <div className="d-flex flex-wrap gap-1 mt-1">
                                                                            {product.productsNature.map((nature, index) => (
                                                                                <Badge
                                                                                    key={index}
                                                                                    bg="light"
                                                                                    text="dark"
                                                                                    style={{
                                                                                        fontSize: "10px",
                                                                                        border: "1px solid #ddd"
                                                                                    }}
                                                                                >
                                                                                    {nature}
                                                                                </Badge>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Keywords */}
                                                                {product.keywords && (
                                                                    <div style={{ marginTop: "12px" }}>
                                                                        <div style={{ fontSize: "12px", color: "#6c757d" }}>
                                                                            Keywords
                                                                        </div>
                                                                        <div className="d-flex flex-wrap gap-1 mt-1">
                                                                            {product.keywords.split(",").map((keyword, index) => (
                                                                                <Badge
                                                                                    key={index}
                                                                                    bg="info"
                                                                                    style={{ fontSize: "10px" }}
                                                                                >
                                                                                    {keyword.trim()}
                                                                                </Badge>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Tab.Pane>


                                            {/* Category Details Tab */}
                                            <Tab.Pane eventKey="category">
                                                <Card className="shadow-sm border-0 mb-4">
                                                    <Card.Header className="bg-light border-0 py-3">
                                                        <h5 className="mb-0 fw-bold">
                                                            <i className="bi bi-layers me-2"></i>Category Details
                                                        </h5>
                                                    </Card.Header>
                                                    <Card.Body className="p-4">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="mb-4">
                                                                    <h6 className="fw-semibold text-muted mb-3">Category Information</h6>
                                                                    <div className='d-flex justify-content-between align-items-center'>
                                                                        <h5 className="fw-bold mb-1">{category.name}</h5>
                                                                        <Badge bg={category.status === "ACTIVE" ? "success" : "secondary"}>
                                                                            {category.status}
                                                                        </Badge>
                                                                    </div>
                                                                    <div className="d-flex mb-3">
                                                                        {category.bannerImage && (
                                                                            <div className="me-3">
                                                                                <img
                                                                                    src={`${category.bannerImage}`}
                                                                                    alt={category.name}
                                                                                    className="rounded shadow"
                                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                    <p className="text-muted">{category.description}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="mb-3">
                                                                            <span className="text-muted d-block">Sequence No</span>
                                                                            <span className="fw-semibold">{category.sequenceNumber}</span>
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <span className="text-muted d-block">Order Type</span>
                                                                            <span className="fw-semibold">{category.orderType}</span>
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <span className="text-muted d-block">Event Category</span>
                                                                            <span className="fw-semibold">
                                                                                {category.isEventCategory ? 'Yes' : 'No'}
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="mb-3">
                                                                            <span className="text-muted d-block">Combo Category</span>
                                                                            <span className="fw-semibold">
                                                                                {category.isComboCategory ? 'Yes' : 'No'}
                                                                            </span>
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <span className="text-muted d-block">Excluded Outlets</span>
                                                                            <span className="fw-semibold">
                                                                                {category?.excludedOutlets?.length > 0
                                                                                    ? category.excludedOutlets.map(o => o.name).join(', ')
                                                                                    : 'Available in All Outlets'
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <span className="text-muted d-block">Display Image</span>
                                                                            {category.displayImage && (
                                                                                <img
                                                                                    src={`${category.displayImage}`}
                                                                                    alt="Display"
                                                                                    className="rounded mt-1"
                                                                                    style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Tab.Pane>

                                            {/* Pricing Tab */}
                                            <Tab.Pane eventKey="pricing">
                                                {menuGroupPricing.length > 0 && (
                                                    <Card className="shadow-sm border-0 mb-4">
                                                        <Card.Header className="bg-light border-0 py-3">
                                                            <h5 className="mb-0 fw-semibold">
                                                                <i className="bi bi-currency-rupee me-2"></i>Pricing by Menu Groups
                                                            </h5>
                                                        </Card.Header>
                                                        <Card.Body className="p-0">
                                                            <Table responsive hover className="mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th className="ps-4">Menu Group</th>
                                                                        <th className="ps-4">Costing</th>
                                                                        <th className="text-end">MRP Price</th>
                                                                        <th className="text-end">Offer Price</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {menuGroupPricing.map((group, index) => {
                                                                        const discount = group.mrpPrice - group.offerPrice;
                                                                        const discountPercent = group.mrpPrice > 0 ? Math.round((discount / group.mrpPrice) * 100) : 0;
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="ps-4">
                                                                                    <span >{group.menuGroup?.name}</span>
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    <span className="text-muted">
                                                                                        {formatPrice(product?.productCost)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    <span className="text-muted">
                                                                                        {formatPrice(group.mrpPrice)}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    <span className="fw-bold text-success">
                                                                                        {formatPrice(group.offerPrice)}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </Table>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                            </Tab.Pane>

                                            {/* Addons Tab */}
                                            <Tab.Pane eventKey="addons">
                                                {addons.length > 0 ? (
                                                    <Card className="shadow-sm border-0 mb-4">
                                                        <Card.Header className="bg-light border-0 py-3 d-flex justify-content-between align-items-center">
                                                            <h5 className="mb-0 fw-bold">
                                                                <i className="bi bi-plus-circle me-2"></i>Available Addons
                                                                <span className="ms-2 text-primary fw-normal">({addons.length})</span>
                                                            </h5>
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() => setShowAllAddons(true)}
                                                            >
                                                                View All Details
                                                            </Button>
                                                        </Card.Header>
                                                        <Card.Body className="p-0">
                                                            <Table responsive hover className="mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th className="ps-4">Addon</th>
                                                                        <th>Description</th>
                                                                        <th>Type</th>
                                                                        <th>Status</th>
                                                                        <th className="pe-4">Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {addons.map((addon, index) => (
                                                                        <tr key={index}>
                                                                            <td className="ps-4">
                                                                                <div className="fw-semibold">{addon.title}</div>
                                                                                <div className="text-muted small">{addon.identifier}</div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="text-muted small">
                                                                                    {addon.description || 'No description'}
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <Badge bg={addon.isMultipleSelect ? "info" : "secondary"}>
                                                                                    {addon.isMultipleSelect ? "Multi-select" : "Single-select"}
                                                                                </Badge>
                                                                            </td>
                                                                            <td>
                                                                                {addon.status === "ACTIVE" ? (
                                                                                    <Badge bg="success">Active</Badge>
                                                                                ) : (
                                                                                    <Badge bg="secondary">Inactive</Badge>
                                                                                )}
                                                                            </td>
                                                                            <td className="pe-4">
                                                                                <Button
                                                                                    variant="outline-secondary"
                                                                                    size="sm"
                                                                                    onClick={(e) => {
                                                                                        e.currentTarget.blur(); // removes focus so color resets
                                                                                        handleViewAddonDetails(addon);
                                                                                    }}

                                                                                >
                                                                                    View Details
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </Card.Body>
                                                    </Card>
                                                ) : (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Body className="text-center py-5">
                                                            {/* <i className="bi bi-plus-circle display-1 text-muted mb-3"></i> */}
                                                            <h5>No Addons Available</h5>
                                                            <p className="text-muted">This product doesn't have any addons configured.</p>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                            </Tab.Pane>

                                            {/* Coupons Tab */}
                                            <Tab.Pane eventKey="coupons">
                                                {coupons.length > 0 ? (
                                                    <>
                                                        <Card className="shadow-sm border-0 mb-4">
                                                            <Card.Header className="bg-light border-0 py-3">
                                                                <h5 className="mb-0 fw-bold">
                                                                    <i className="bi bi-tag me-2"></i>Applicable Coupons
                                                                    <span className="ms-2 text-primary fw-normal">({coupons.length})</span>
                                                                </h5>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                {/* Search and Filter Controls */}
                                                                <div className="row mb-4">
                                                                    <div className="col-md-8">
                                                                        <InputGroup>
                                                                            <InputGroup.Text>
                                                                                <Search />
                                                                            </InputGroup.Text>
                                                                            <Form.Control
                                                                                placeholder="Search coupons by title, code, or description..."
                                                                                value={couponSearch}
                                                                                onChange={(e) => {
                                                                                    setCouponSearch(e.target.value);
                                                                                    setCurrentCouponPage(1);
                                                                                }}
                                                                            />
                                                                        </InputGroup>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <InputGroup>
                                                                            <InputGroup.Text>
                                                                                <Filter />
                                                                            </InputGroup.Text>
                                                                            <Form.Select
                                                                                value={couponFilter}
                                                                                onChange={(e) => {
                                                                                    setCouponFilter(e.target.value);
                                                                                    setCurrentCouponPage(1);
                                                                                }}
                                                                            >
                                                                                <option value="ALL">All Types</option>
                                                                                <option value="PERCENTAGE">Percentage Discount</option>
                                                                                <option value="FIXED_AMOUNT">Fixed Amount</option>
                                                                                <option value="FIXED_PRICE">Fixed Price</option>
                                                                                <option value="BOGO">BOGO</option>
                                                                                <option value="FREEBIE">Freebie</option>
                                                                                <option value="SIZE_UPGRADE">Size Upgrade</option>
                                                                                <option value="ACTIVE">Active Only</option>
                                                                                <option value="INACTIVE">Inactive Only</option>
                                                                            </Form.Select>
                                                                        </InputGroup>
                                                                    </div>
                                                                </div>

                                                                {/* Results Summary */}
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <div className="text-muted">
                                                                        Showing {currentCoupons.length} of {filteredCoupons.length} coupons
                                                                        {couponSearch && (
                                                                            <span className="ms-2">
                                                                                for "{couponSearch}"
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="text-muted">
                                                                        Page {currentCouponPage} of {totalCouponPages}
                                                                    </div>
                                                                </div>

                                                                {/* Coupons Table */}
                                                                {filteredCoupons.length === 0 ? (
                                                                    <div className="text-center py-5">
                                                                        <i className="bi bi-search display-1 text-muted mb-3"></i>
                                                                        <h5>No coupons found</h5>
                                                                        <p className="text-muted">
                                                                            Try adjusting your search or filter criteria
                                                                        </p>
                                                                    </div>
                                                                ) : (
                                                                    <div className="table-responsive" style={{ fontSize: "12px" }}>
                                                                        {filteredCoupons.length === 0 ? (
                                                                            <div className="text-center py-4" style={{ fontSize: "13px" }}>
                                                                                <i
                                                                                    className="bi bi-search mb-2"
                                                                                    style={{ fontSize: "40px", color: "#6c757d" }}
                                                                                ></i>
                                                                                <h6 style={{ margin: 0 }}>No coupons found</h6>
                                                                                <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                                                                                    Try adjusting your search or filter criteria
                                                                                </p>
                                                                            </div>
                                                                        ) : (
                                                                            <Table hover className="mb-0" style={{ fontSize: "12px" }}>
                                                                                <thead
                                                                                    className="table-light"
                                                                                    style={{
                                                                                        fontSize: "12px",
                                                                                        textTransform: "uppercase",
                                                                                        letterSpacing: "0.3px"
                                                                                    }}
                                                                                >
                                                                                    <tr>
                                                                                        <th style={{ padding: "6px" }}>Code</th>
                                                                                        <th style={{ padding: "6px" }}>Title</th>
                                                                                        <th style={{ padding: "6px" }}>Type</th>
                                                                                        <th style={{ padding: "6px" }}>Value</th>
                                                                                        <th style={{ padding: "6px" }}>Conditions</th>
                                                                                        <th style={{ padding: "6px" }}>Usage / Validity</th>
                                                                                        <th style={{ padding: "6px" }}>Status</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    {currentCoupons.map((coupon, index) => {
                                                                                        const couponType = getCouponTypeForFilter(coupon);

                                                                                        // status calculation
                                                                                        const now = new Date();
                                                                                        const start = coupon.validityStartDate
                                                                                            ? new Date(coupon.validityStartDate)
                                                                                            : null;
                                                                                        const end = coupon.validityEndDate
                                                                                            ? new Date(coupon.validityEndDate)
                                                                                            : null;

                                                                                        let statusText = coupon.status;
                                                                                        let statusColor = "secondary";

                                                                                        if (start && now < start) {
                                                                                            statusText = "UPCOMING";
                                                                                            statusColor = "warning";
                                                                                        } else if (start && end && now >= start && now <= end) {
                                                                                            statusText = "ACTIVE";
                                                                                            statusColor = "success";
                                                                                        } else if (end && now > end) {
                                                                                            statusText = "EXPIRED";
                                                                                            statusColor = "danger";
                                                                                        }

                                                                                        return (
                                                                                            <tr key={index}>
                                                                                                {/* Code */}
                                                                                                <td style={{ padding: "6px", fontWeight: "500" }}>
                                                                                                    {coupon.couponCode}
                                                                                                </td>

                                                                                                {/* Title */}
                                                                                                <td style={{ padding: "6px" }}>
                                                                                                    <div style={{ fontWeight: "500" }}>
                                                                                                        {coupon.title}
                                                                                                    </div>

                                                                                                    {/* {coupon.description && (
                                                                                                        <div
                                                                                                            style={{
                                                                                                                fontSize: "11px",
                                                                                                                color: "#6c757d",
                                                                                                                marginTop: "2px",
                                                                                                                whiteSpace: "normal",
                                                                                                                wordBreak: "break-word"
                                                                                                            }}
                                                                                                        >
                                                                                                            {coupon.description}
                                                                                                        </div>
                                                                                                    )} */}
                                                                                                </td>

                                                                                                {/* Type */}
                                                                                                <td style={{ padding: "6px" }}>
                                                                                                    <div
                                                                                                        style={{
                                                                                                            display: "flex",
                                                                                                            alignItems: "center",
                                                                                                            gap: "4px"
                                                                                                        }}
                                                                                                    >
                                                                                                        {getCouponTypeIcon(coupon)}

                                                                                                        <Badge
                                                                                                            bg={getCouponTypeColor(couponType)}
                                                                                                            style={{
                                                                                                                fontSize: "10px",
                                                                                                                padding: "4px 6px"
                                                                                                            }}
                                                                                                        >
                                                                                                            {getCouponTypeText(coupon)}
                                                                                                        </Badge>
                                                                                                    </div>
                                                                                                </td>

                                                                                                {/* Value */}
                                                                                                <td style={{ padding: "6px", fontWeight: "500" }}>
                                                                                                    {coupon.discountPercent &&
                                                                                                        `${coupon.discountPercent}%`}

                                                                                                    {coupon.discountAmount &&
                                                                                                        `₹${coupon.discountAmount}`}

                                                                                                    {coupon.discountPrice &&
                                                                                                        `₹${coupon.discountPrice}`}

                                                                                                    {coupon.isBogoCoupon && "BOGO"}

                                                                                                    {coupon.newSizeUpgradeAddon &&
                                                                                                        "Size Upgrade"}

                                                                                                    {coupon.isFreebieCoupon && "Freebie"}
                                                                                                </td>

                                                                                                {/* Conditions */}
                                                                                                <td style={{ padding: "6px" }}>
                                                                                                    {(coupon.minOrderAmount ||
                                                                                                        coupon.maxDiscountAmount) && (
                                                                                                            <div style={{ fontSize: "11px" }}>
                                                                                                                {coupon.minOrderAmount && (
                                                                                                                    <div>
                                                                                                                        Min: ₹
                                                                                                                        {coupon.minOrderAmount}
                                                                                                                    </div>
                                                                                                                )}

                                                                                                                {coupon.maxDiscountAmount && (
                                                                                                                    <div>
                                                                                                                        Max: ₹
                                                                                                                        {coupon.maxDiscountAmount}
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        )}
                                                                                                </td>

                                                                                                {/* Usage & Validity */}
                                                                                                <td style={{ padding: "6px" }}>
                                                                                                    <div style={{ fontWeight: "500" }}>
                                                                                                        {coupon?.usageType === "MULTIPLE"
                                                                                                            ? "Multiple Use"
                                                                                                            : "One Time"}
                                                                                                    </div>

                                                                                                    {/* <div
                                                                                                        style={{
                                                                                                            fontSize: "11px",
                                                                                                            color: "#6c757d"
                                                                                                        }}
                                                                                                    >
                                                                                                        {coupon?.validityStartDate ? coupon?.validityStartDate?.toLocaleDateString() : "No Start"}
                                                                                                        {" - "}
                                                                                                        {coupon?.validityEndDate ? coupon?.validityEndDate?.toLocaleDateString() : "No End"}
                                                                                                    </div> */}
                                                                                                    <div
                                                                                                        style={{
                                                                                                            fontSize: "11px",
                                                                                                            color: "#6c757d"
                                                                                                        }}
                                                                                                    >
                                                                                                        {coupon?.validityStartDate
                                                                                                            ? new Date(coupon.validityStartDate).toLocaleDateString()
                                                                                                            : "No Start"}
                                                                                                        {" - "}
                                                                                                        {coupon?.validityEndDate
                                                                                                            ? new Date(coupon.validityEndDate).toLocaleDateString()
                                                                                                            : "No End"}
                                                                                                    </div>
                                                                                                </td>

                                                                                                {/* Status */}
                                                                                                <td style={{ padding: "6px" }}>
                                                                                                    <Badge
                                                                                                        bg={statusColor}
                                                                                                        style={{
                                                                                                            fontSize: "10px",
                                                                                                            padding: "4px 6px"
                                                                                                        }}
                                                                                                    >
                                                                                                        {statusText}
                                                                                                    </Badge>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </Table>
                                                                        )}
                                                                    </div>

                                                                )}
                                                            </Card.Body>
                                                        </Card>

                                                        {/* Pagination */}
                                                        {totalCouponPages > 1 && (
                                                            <Card className="shadow-sm border-0">
                                                                <Card.Body className="d-flex justify-content-center">
                                                                    <Pagination>
                                                                        <Pagination.Prev
                                                                            onClick={() => handleCouponPageChange(currentCouponPage - 1)}
                                                                            disabled={currentCouponPage === 1}
                                                                        />
                                                                        {renderPagination(currentCouponPage, totalCouponPages, handleCouponPageChange)}
                                                                        <Pagination.Next
                                                                            onClick={() => handleCouponPageChange(currentCouponPage + 1)}
                                                                            disabled={currentCouponPage === totalCouponPages}
                                                                        />
                                                                    </Pagination>
                                                                </Card.Body>
                                                            </Card>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Body className="text-center py-5">
                                                            <i className="bi bi-tag display-1 text-muted mb-3"></i>
                                                            <h5>No Coupons Available</h5>
                                                            <p className="text-muted">No coupons are applicable to this product.</p>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                            </Tab.Pane>

                                            {/* Subscriptions Tab */}
                                            <Tab.Pane eventKey="subscriptions">
                                                {eligibleSubscriptions.length > 0 ? (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Header className="bg-light border-0 py-3 d-flex justify-content-between align-items-center">
                                                            <h5 className="mb-0 fw-bold">
                                                                <i className="bi bi-calendar-check me-2"></i>Eligible Subscriptions
                                                                <span className="ms-2 text-primary fw-normal">({eligibleSubscriptions.length})</span>
                                                            </h5>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <div className="row">
                                                                {eligibleSubscriptions.map((subscription, index) => (
                                                                    <div key={index} className="col-md-6 mb-4">
                                                                        {/* <Card className="h-100 border shadow-sm">
                                                                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    <h6 className="fw-bold mb-0">{subscription.title}</h6>
                                                                                    <div className="text-muted small">{subscription.subTitle}</div>
                                                                                </div>
                                                                                {getSubscriptionStatusBadge(subscription.status)}
                                                                            </Card.Header> */}
                                                                        <Card className="h-100 border shadow-sm">
                                                                            <Card.Header className="bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    <h6 className="fw-semibold mb-0 small">
                                                                                        {subscription.title}
                                                                                    </h6>
                                                                                    <div className="text-muted" style={{ fontSize: '12px' }}>
                                                                                        {subscription.subTitle}
                                                                                    </div>
                                                                                </div>
                                                                                {getSubscriptionStatusBadge(subscription.status)}
                                                                            </Card.Header>

                                                                            <Card.Body className="p-3">

                                                                                {/* Small Image */}
                                                                                {subscription.banner && (
                                                                                    <div className="mb-2 text-center">
                                                                                        <img
                                                                                            src={subscription.banner}
                                                                                            alt={subscription.title}
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                height: '120px',
                                                                                                objectFit: 'cover',
                                                                                                borderRadius: '6px'
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                )}

                                                                                {/* Price + Duration */}
                                                                                <div className="d-flex justify-content-between mb-2">
                                                                                    <div>
                                                                                        <div className="text-muted" style={{ fontSize: '11px' }}>Price</div>
                                                                                        <div className="fw-bold text-success small">
                                                                                            {formatPrice(subscription.price)}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <div className="text-muted" style={{ fontSize: '11px' }}>Duration</div>
                                                                                        <div className="fw-semibold small">
                                                                                            {subscription.duration}d
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Quantity + Threshold */}
                                                                                <div className="d-flex justify-content-between mb-2">
                                                                                    <div>
                                                                                        <div className="text-muted" style={{ fontSize: '11px' }}>Qty</div>
                                                                                        <div className="small">{subscription.orderQuantity}</div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <div className="text-muted" style={{ fontSize: '11px' }}>Every</div>
                                                                                        <div className="small">
                                                                                            {subscription.orderThreshold} hrs
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Tax + Type */}
                                                                                <div className="d-flex justify-content-between mb-2">
                                                                                    <div className="small">
                                                                                        {getSubscriptionTypeBadge(subscription.subscriptionType)}
                                                                                    </div>
                                                                                    <div className="small">
                                                                                        {subscription.taxPercent}% Tax
                                                                                    </div>
                                                                                </div>

                                                                                {/* Excluded Days */}
                                                                                <div className="mb-1" style={{ fontSize: '12px' }}>
                                                                                    <span className="text-muted">Excluded Days: </span>
                                                                                    {subscription.excludedDays?.length > 0
                                                                                        ? subscription.excludedDays.join(', ')
                                                                                        : 'None'}
                                                                                </div>

                                                                                {/* Excluded Addons */}
                                                                                <div style={{ fontSize: '12px' }}>
                                                                                    <span className="text-muted">Excluded Addons: </span>
                                                                                    {subscription.excludedAddonValues?.length > 0
                                                                                        ? subscription.excludedAddonValues.length
                                                                                        : 0}
                                                                                </div>

                                                                            </Card.Body>
                                                                        </Card>

                                                                        {/* </Card> */}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                ) : (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Body className="text-center py-5">
                                                            <i className="bi bi-calendar-check display-1 text-muted mb-3"></i>
                                                            <h5>No Subscriptions Available</h5>
                                                            <p className="text-muted">No subscriptions are eligible for this product.</p>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                            </Tab.Pane>

                                            {/* Outlet Availability Tab */}
                                            <Tab.Pane eventKey="outlets">
                                                <Card className="shadow-sm border-0">
                                                    <Card.Header className="bg-light border-0 py-3">
                                                        <h5 className="mb-0 fw-bold">
                                                            <i className="bi bi-shop me-2"></i>Outlet Availability
                                                        </h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col md={8}>
                                                                <Card className="mb-4">
                                                                    <Card.Header>
                                                                        <h6 className="mb-0">Available Outlets ({outletAvailability.length})</h6>
                                                                    </Card.Header>
                                                                    <Card.Body className="p-0">
                                                                        <Table responsive hover className="mb-0">
                                                                            <thead className="table-light">
                                                                                <tr>
                                                                                    <th className="ps-4">Outlet Name</th>
                                                                                    <th>Status</th>
                                                                                    {/* <th>Location</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {outletAvailability.map((outlet, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="ps-4">
                                                                                            <div className="d-flex align-items-center">
                                                                                                <Shop className="me-3 text-muted" />
                                                                                                <span className="fw-semibold">{outlet.outletName}</span>
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* <td>
                                                                                            {(product.status === 'INACTIVE' || category.status === 'INACTIVE')
                                                                                                ? getOutletStatusBadge('NOT_AVAILABLE')
                                                                                                : getOutletStatusBadge(outlet.status)}
                                                                                        </td> */}
                                                                                        <td>
                                                                                            {(product.status === 'INACTIVE' ||
                                                                                                category.status === 'INACTIVE' ||
                                                                                                excludedOutlets.some(excluded => excluded._id === outlet.outletId))
                                                                                                ? getOutletStatusBadge('NOT_AVAILABLE')
                                                                                                : getOutletStatusBadge(outlet.status)}
                                                                                        </td>
                                                                                        {/* <td>
                                                                                            <small className="text-muted">{outlet.address || 'N/A'}</small>
                                                                                        </td> */}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Card>
                                                                    <Card.Header>
                                                                        <h6 className="mb-0">Availability Summary</h6>
                                                                    </Card.Header>
                                                                    <Card.Body>
                                                                        <div className="text-center mb-4">
                                                                            <h2 className="fw-bold">{outletAvailability.length}</h2>
                                                                            <p className="text-muted">Total Available Outlets</p>
                                                                        </div>

                                                                        <div className="mb-3">
                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                <span>In Stock</span>
                                                                                <span className="fw-semibold">
                                                                                    {outletAvailability.filter(o => o.status === "IN_STOCK").length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="progress" style={{ height: '8px' }}>
                                                                                <div
                                                                                    className="progress-bar bg-success"
                                                                                    style={{ width: `${(outletAvailability.filter(o => o.status === "IN_STOCK").length / outletAvailability.length) * 100}%` }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="mb-3">
                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                <span>Out of Stock</span>
                                                                                <span className="fw-semibold">
                                                                                    {outletAvailability.filter(o => o.status === "OUT_OF_STOCK").length}
                                                                                </span>
                                                                            </div>
                                                                            <div className="progress" style={{ height: '8px' }}>
                                                                                <div
                                                                                    className="progress-bar bg-danger"
                                                                                    style={{ width: `${(outletAvailability.filter(o => o.status === "OUT_OF_STOCK").length / outletAvailability.length) * 100}%` }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        {excludedOutlets.length > 0 && (
                                                                            <div className="mt-4">
                                                                                <h6 className="fw-semibold mb-2">Excluded Outlets ({excludedOutlets.length})</h6>
                                                                                <div className="border rounded p-2">
                                                                                    {excludedOutlets.map((outlet, index) => (
                                                                                        <div key={index} className="d-flex align-items-center mb-2">
                                                                                            <Ban className="me-2 text-danger" size={14} />
                                                                                            <span className="text-muted small">{outlet.name || `Outlet ${index + 1}`}</span>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Tab.Pane>

                                            {/* Advertisements Tab */}
                                            <Tab.Pane eventKey="advertisements">

                                                {(advertisements.length > 0 || inAppAdvertisements.length > 0) ? (
                                                    <>

                                                        {/* Banner Advertisements */}
                                                        {advertisements.length > 0 && (
                                                            <Card className="shadow-sm border-0 mb-4">

                                                                <Card.Header className="bg-light border-0 py-3">
                                                                    <h5 className="mb-0 fw-bold">
                                                                        <i className="bi bi-megaphone me-2"></i>
                                                                        Banner Advertisements
                                                                        <span className="ms-2 text-primary fw-normal">
                                                                            ({advertisements.length})
                                                                        </span>
                                                                    </h5>
                                                                </Card.Header>

                                                                <Card.Body className="p-0">

                                                                    <Table responsive hover className="mb-0">

                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th className="ps-4">Advertisement</th>
                                                                                <th>Title</th>
                                                                                <th>Validity</th>
                                                                                <th>Excluded Outlets</th>
                                                                                <th className="pe-4">Actions</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>

                                                                            {advertisements.map((ad, index) => (

                                                                                <tr key={index}>

                                                                                    {/* Image */}
                                                                                    <td className="ps-4">
                                                                                        {ad.adImagePath && (
                                                                                            <img
                                                                                                src={ad.adImagePath}
                                                                                                alt={ad.title}
                                                                                                className="rounded"
                                                                                                style={{
                                                                                                    width: '60px',
                                                                                                    height: '60px',
                                                                                                    objectFit: 'cover'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </td>

                                                                                    {/* Title */}
                                                                                    <td>
                                                                                        <div className="fw-semibold">
                                                                                            {ad.title}
                                                                                        </div>
                                                                                        <div className="text-muted small">
                                                                                            Sequence: {ad.sequenceNo}
                                                                                        </div>
                                                                                    </td>

                                                                                    {/* Validity */}
                                                                                    <td>
                                                                                        <div className="small">
                                                                                            <div>
                                                                                                From: {new Date(ad.validityStartDate).toLocaleDateString()}
                                                                                            </div>
                                                                                            <div>
                                                                                                To: {new Date(ad.validityEndDate).toLocaleDateString()}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>

                                                                                    {/* Excluded outlets */}
                                                                                    <td>
                                                                                        <div className="small">
                                                                                            {ad.excludedOutlets?.length > 0
                                                                                                ? ad.excludedOutlets.map(o => o.name).join(', ')
                                                                                                : 'None'}
                                                                                        </div>
                                                                                    </td>

                                                                                    {/* Action */}
                                                                                    <td className="pe-4">
                                                                                        <Button
                                                                                            variant="outline-info"
                                                                                            size="sm"
                                                                                            onClick={(e) => {
                                                                                                e.currentTarget.blur();
                                                                                                handleViewAdDetails(ad);
                                                                                            }}
                                                                                        >
                                                                                            View Details
                                                                                        </Button>
                                                                                    </td>

                                                                                </tr>

                                                                            ))}

                                                                        </tbody>

                                                                    </Table>

                                                                </Card.Body>

                                                            </Card>
                                                        )}


                                                        {/* In-App Advertisements */}
                                                        {inAppAdvertisements.length > 0 && (

                                                            <Card className="shadow-sm border-0">

                                                                <Card.Header className="bg-light border-0 py-3">
                                                                    <h5 className="mb-0 fw-bold">
                                                                        <i className="bi bi-phone me-2"></i>
                                                                        In-App Advertisements
                                                                        <span className="ms-2 text-primary fw-normal">
                                                                            ({inAppAdvertisements.length})
                                                                        </span>
                                                                    </h5>
                                                                </Card.Header>

                                                                <Card.Body>

                                                                    <Row>

                                                                        {inAppAdvertisements.map((ad, index) => (

                                                                            <Col md={6} key={index} className="mb-3">

                                                                                <Card className="border h-100 shadow-sm">

                                                                                    <Card.Body className="p-3">

                                                                                        <div className="d-flex align-items-start mb-2">

                                                                                            {/* Image */}
                                                                                            {ad.adImagePath && (
                                                                                                <img
                                                                                                    src={ad.adImagePath}
                                                                                                    alt={ad.title}
                                                                                                    className="rounded me-3"
                                                                                                    style={{
                                                                                                        width: '70px',
                                                                                                        height: '70px',
                                                                                                        objectFit: 'cover'
                                                                                                    }}
                                                                                                />
                                                                                            )}

                                                                                            {/* Title and status */}
                                                                                            <div>

                                                                                                <h6 className="fw-semibold mb-1">
                                                                                                    {ad.title}
                                                                                                </h6>

                                                                                                <Badge bg="success">
                                                                                                    Active
                                                                                                </Badge>

                                                                                            </div>

                                                                                        </div>


                                                                                        {/* Validity */}
                                                                                        <div className="small mb-1">
                                                                                            <span className="text-muted">Validity: </span>
                                                                                            {new Date(ad.validityStartDate).toLocaleDateString()}
                                                                                            {" - "}
                                                                                            {new Date(ad.validityEndDate).toLocaleDateString()}
                                                                                        </div>


                                                                                        {/* Excluded outlets */}
                                                                                        <div className="small mb-1">
                                                                                            <span className="text-muted">Excluded outlets: </span>

                                                                                            {ad.excludedOutlets?.length > 0
                                                                                                ? ad.excludedOutlets.map(o => o.name).join(', ')
                                                                                                : 'None'}
                                                                                        </div>


                                                                                        {/* Created date */}
                                                                                        <div className="text-muted small">
                                                                                            Created: {new Date(ad.createdAt).toLocaleDateString()}
                                                                                        </div>

                                                                                    </Card.Body>

                                                                                </Card>

                                                                            </Col>

                                                                        ))}

                                                                    </Row>

                                                                </Card.Body>

                                                            </Card>

                                                        )}

                                                    </>
                                                ) : (

                                                    <Card className="shadow-sm border-0">

                                                        <Card.Body className="text-center py-5">

                                                            <i className="bi bi-megaphone display-5 text-muted mb-3"></i>

                                                            <h6>No Advertisements</h6>

                                                            <p className="text-muted small">
                                                                No advertisements are associated with this product.
                                                            </p>

                                                        </Card.Body>

                                                    </Card>

                                                )}

                                            </Tab.Pane>


                                            {/* Raw Materials Tab */}
                                            <Tab.Pane eventKey="rawMaterials">
                                                {rawMaterialAutoDeduction.length > 0 ? (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Header className="bg-light border-0 py-3 d-flex justify-content-between align-items-center">
                                                            <h5 className="mb-0 fw-bold">
                                                                <i className="bi bi-boxes me-2"></i>Menu Ingredients
                                                                <span className="ms-2 text-primary fw-normal">({rawMaterialAutoDeduction.length})</span>
                                                            </h5>
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() => setShowRawMaterials(true)}
                                                            >
                                                                View All Details
                                                            </Button>
                                                        </Card.Header>
                                                        <Card.Body className="p-0">
                                                            <Table responsive hover className="mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th className="ps-4">Raw Material</th>
                                                                        <th>Quantity</th>
                                                                        <th>Unit</th>
                                                                        <th>Deduction Type</th>
                                                                        <th>Important</th>
                                                                        <th className="pe-4">Addon Based</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {rawMaterialAutoDeduction.map((material, index) => (
                                                                        <tr key={index}>
                                                                            <td className="ps-4">
                                                                                <div className="fw-semibold">{material.rawMaterial?.name}</div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="fw-bold">{material.quantity}</div>
                                                                            </td>
                                                                            <td>
                                                                                <span className="text-muted">{material.rawMaterial?.unit}</span>
                                                                            </td>
                                                                            <td>
                                                                                <Badge bg={material.deductionType === "PRODUCT_WISE" ? "info" : "warning"}>
                                                                                    {material.deductionType === "PRODUCT_WISE" ? "Product" : "Addon"}
                                                                                </Badge>
                                                                            </td>
                                                                            <td>
                                                                                {material.isImportant ? (
                                                                                    <Badge bg="danger">Required</Badge>
                                                                                ) : (
                                                                                    <Badge bg="secondary">Optional</Badge>
                                                                                )}
                                                                            </td>
                                                                            <td className="pe-4">
                                                                                {material.addonId ? (
                                                                                    <span className="text-info">Yes</span>
                                                                                ) : (
                                                                                    <span className="text-muted">No</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </Card.Body>
                                                    </Card>
                                                ) : (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Body className="text-center py-5">
                                                            <i className="bi bi-boxes display-1 text-muted mb-3"></i>
                                                            <h5>No Raw Materials</h5>
                                                            <p className="text-muted">No raw materials are required for this product.</p>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                            </Tab.Pane>

                                            {/* Update History Tab */}
                                            <Tab.Pane eventKey="updates">
                                                {productUpdateLogs.length > 0 ? (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Header className="bg-light border-0 py-3">
                                                            <h5 className="mb-0 fw-bold">
                                                                <i className="bi bi-clock-history me-2"></i>Update History
                                                                <span className="ms-2 text-primary fw-normal">({productUpdateLogs.length})</span>
                                                            </h5>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <div className="timeline">
                                                                {productUpdateLogs.map((log, index) => (
                                                                    <div key={index} className="timeline-item mb-4">
                                                                        <div className="d-flex">
                                                                            <div className="timeline-marker me-3">
                                                                                <div className="bg-primary rounded-circle" style={{ width: '12px', height: '12px' }}></div>
                                                                            </div>
                                                                            <div className="flex-grow-1">
                                                                                <div className="d-flex justify-content-between align-items-start mb-1">
                                                                                    <h6 className="fw-semibold mb-0">{log.event}</h6>
                                                                                    <small className="text-muted">
                                                                                        {new Date(log.createdAt).toLocaleDateString()} {new Date(log.createdAt).toLocaleTimeString()}
                                                                                    </small>
                                                                                </div>
                                                                                <div className="mb-2">
                                                                                    <small className="text-muted">
                                                                                        Updated by: {log.updatedBy?.name} ({log.updatedBy?.type})
                                                                                    </small>
                                                                                </div>
                                                                                {log.updated_fields && log.updated_fields.length > 0 && (
                                                                                    <Card className="border">
                                                                                        <Card.Body className="p-2">
                                                                                            <small className="fw-semibold d-block mb-2">Changes:</small>
                                                                                            {log.updated_fields.map((field, i) => (
                                                                                                <div key={i} className="small mb-2">
                                                                                                    <span className="fw-medium">{field.field}:</span>{' '}
                                                                                                    <span className="text-danger">"{field.oldValue}"</span>{' '}
                                                                                                    →{' '}
                                                                                                    <span className="text-success">"{field.newValue}"</span>
                                                                                                </div>
                                                                                            ))}
                                                                                        </Card.Body>
                                                                                    </Card>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                ) : (
                                                    <Card className="shadow-sm border-0">
                                                        <Card.Body className="text-center py-5">
                                                            <i className="bi bi-clock-history display-1 text-muted mb-3"></i>
                                                            <h5>No Update History</h5>
                                                            <p className="text-muted">No update logs available for this product.</p>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>

                                {/* Addon Details Modal */}
                                <Modal
                                    show={showAddonDetails}
                                    onHide={() => setShowAddonDetails(false)}
                                    size="lg"
                                >
                                    <Modal.Header closeButton className="bg-light">
                                        <Modal.Title>
                                            <i className="bi bi-plus-circle me-2"></i>
                                            Addon Details
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {selectedAddon && (
                                            <>
                                                <div className="mb-4">
                                                    <h5 className="fw-bold mb-2">{selectedAddon.title}</h5>
                                                    <p className="text-muted">{selectedAddon.description}</p>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="mb-2">
                                                                <span className="text-muted">Identifier:</span>
                                                                <code className="ms-2">{selectedAddon.identifier}</code>
                                                            </div>
                                                            <div className="mb-2">
                                                                <span className="text-muted">Status:</span>
                                                                <Badge bg={selectedAddon.status === "ACTIVE" ? "success" : "secondary"} className="ms-2">
                                                                    {selectedAddon.status}
                                                                </Badge>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-2">
                                                                <span className="text-muted">Selection Type:</span>
                                                                <span className="fw-semibold ms-2">
                                                                    {selectedAddon.isMultipleSelect ? "Multiple Select" : "Single Select"}
                                                                </span>
                                                            </div>
                                                            <div className="mb-2">
                                                                <span className="text-muted">Order Type:</span>
                                                                <span className="fw-semibold ms-2">{selectedAddon.orderType}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {selectedAddon.badgeImage && (
                                                        <div className="mb-3">
                                                            <span className="text-muted d-block mb-2">Badge Image:</span>
                                                            <img
                                                                src={`${selectedAddon.badgeImage}`}
                                                                alt="Badge"
                                                                className="rounded"
                                                                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                <h6 className="fw-semibold mb-3">Addon Values</h6>
                                                <Table responsive hover>
                                                    <thead>
                                                        <tr>
                                                            <th>Value</th>
                                                            <th>Price</th>
                                                            <th>Default</th>
                                                            <th>Status</th>
                                                            {/* <th>Excluded Outlets</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedAddon.addonValues?.map((value, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="fw-semibold">{value.value}</div>
                                                                    {value.subLabel && (
                                                                        <div className="text-muted small">{value.subLabel}</div>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <div className="fw-bold text-success">{formatPrice(value.price)}</div>
                                                                </td>
                                                                <td>
                                                                    {value.isDefault ? (
                                                                        <Badge bg="info">Default</Badge>
                                                                    ) : (
                                                                        <span className="text-muted">-</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <Badge bg={value.status === "ACTIVE" ? "success" : "secondary"}>
                                                                        {value.status}
                                                                    </Badge>
                                                                </td>
                                                                {/* <td>
                                                                    <Badge bg="light" text="dark">
                                                                        {value.excludedOutlets?.length || 0} outlets
                                                                    </Badge>
                                                                </td> */}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowAddonDetails(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* Advertisement Details Modal */}
                                <Modal
                                    show={showAdDetails}
                                    onHide={() => setShowAdDetails(false)}
                                    size="lg"
                                >
                                    <Modal.Header closeButton className="bg-light">
                                        <Modal.Title>
                                            <i className="bi bi-megaphone me-2"></i>
                                            Advertisement Details
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {selectedAd && (
                                            <>
                                                <div className="mb-4">
                                                    <h5 className="fw-bold mb-2">{selectedAd.title}</h5>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="mb-2">
                                                                <span className="text-muted">Sequence No:</span>
                                                                <span className="fw-semibold ms-2">{selectedAd.sequenceNo}</span>
                                                            </div>
                                                            <div className="mb-2">
                                                                <span className="text-muted">Validity Start:</span>
                                                                <span className="fw-semibold ms-2">
                                                                    {new Date(selectedAd.validityStartDate).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-2">
                                                                <span className="text-muted">Validity End:</span>
                                                                <span className="fw-semibold ms-2">
                                                                    {new Date(selectedAd.validityEndDate).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                            <div className="mb-2">
                                                                <span className="text-muted">Created:</span>
                                                                <span className="fw-semibold ms-2">
                                                                    {new Date(selectedAd.createdAt).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {selectedAd.excludedOutlets && selectedAd.excludedOutlets.length > 0 && (
                                                    <>
                                                        <h6 className="fw-semibold mb-3">Excluded Outlets ({selectedAd.excludedOutlets.length})</h6>
                                                        <div className="border rounded p-3 mb-4">
                                                            <Row>
                                                                {selectedAd.excludedOutlets.map((outlet, index) => (
                                                                    <Col md={6} key={index} className="mb-2">
                                                                        <div className="d-flex align-items-center">
                                                                            <Ban className="me-2 text-danger" size={14} />
                                                                            <div>
                                                                                <div className="fw-semibold small">{outlet.name}</div>
                                                                                <div className="text-muted small">{outlet.address}</div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowAdDetails(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* Raw Materials Details Modal */}
                                <Modal
                                    show={showRawMaterials}
                                    onHide={() => setShowRawMaterials(false)}
                                    size="xl"
                                >
                                    <Modal.Header closeButton className="bg-light">
                                        <Modal.Title>
                                            <i className="bi bi-boxes me-2"></i>
                                            Raw Material Details
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Table responsive hover>
                                            <thead>
                                                <tr>
                                                    <th>Raw Material</th>
                                                    <th>Quantity</th>
                                                    <th>Unit</th>
                                                    <th>Deduction Type</th>
                                                    <th>Importance</th>
                                                    <th>Optional</th>
                                                    <th>Addon Based</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rawMaterialAutoDeduction.map((material, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="fw-semibold">{material.rawMaterial?.name}</div>
                                                            <div className="text-muted small">ID: {material.rawMaterial?._id}</div>
                                                        </td>
                                                        <td>
                                                            <div className="fw-bold h5">{material.quantity}</div>
                                                        </td>
                                                        <td>
                                                            <span className="fw-semibold">{material.rawMaterial?.unit}</span>
                                                        </td>
                                                        <td>
                                                            <Badge bg={material.deductionType === "PRODUCT_WISE" ? "info" : "warning"}>
                                                                {material.deductionType}
                                                            </Badge>
                                                        </td>
                                                        <td>
                                                            {material.isImportant ? (
                                                                <Badge bg="danger">Required</Badge>
                                                            ) : (
                                                                <Badge bg="secondary">Not Required</Badge>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {material.isOptional ? (
                                                                <Badge bg="success">Yes</Badge>
                                                            ) : (
                                                                <Badge bg="light" text="dark">No</Badge>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {material.addonId ? (
                                                                <div>
                                                                    <div className="fw-semibold small">Addon ID: {material.addonId}</div>
                                                                    {material.addonValueId && (
                                                                        <div className="text-muted small">Value ID: {material.addonValueId}</div>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <span className="text-muted">-</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowRawMaterials(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* All Addons Modal */}
                                <Modal
                                    show={showAllAddons}
                                    onHide={() => setShowAllAddons(false)}
                                    size="xl"
                                >
                                    <Modal.Header closeButton className="bg-light">
                                        <Modal.Title>
                                            <i className="bi bi-plus-circle me-2"></i>
                                            All Addons Details
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {addons.map((addon, index) => (
                                            <Accordion key={index} className="mb-3">
                                                <Accordion.Item eventKey={index.toString()}>
                                                    <Accordion.Header>
                                                        <div className="d-flex justify-content-between align-items-center w-100 me-3">
                                                            <div>
                                                                <span className="fw-semibold">{addon.title}</span>
                                                                <Badge bg="light" text="dark" className="ms-2">{addon.identifier}</Badge>
                                                            </div>
                                                            <div>
                                                                <Badge bg={addon.status === "ACTIVE" ? "success" : "secondary"} className="me-2">
                                                                    {addon.status}
                                                                </Badge>
                                                                <Badge bg={addon.isMultipleSelect ? "info" : "secondary"}>
                                                                    {addon.isMultipleSelect ? "Multi" : "Single"}
                                                                </Badge>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <p className="text-muted mb-3">{addon.description}</p>
                                                        <div className="row mb-3">
                                                            <div className="col-md-4">
                                                                <div className="mb-2">
                                                                    <span className="text-muted">Order Type:</span>
                                                                    <span className="fw-semibold ms-2">{addon.orderType}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="mb-2">
                                                                    <span className="text-muted">Sequence:</span>
                                                                    <span className="fw-semibold ms-2">{addon.sequenceNumber}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="mb-2">
                                                                    <span className="text-muted">Excluded Outlets:</span>
                                                                    <span className="fw-semibold ms-2">{addon.excludedOutlets?.length || 0}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h6 className="fw-semibold mb-2">Values:</h6>
                                                        <Table size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Value</th>
                                                                    <th>Price</th>
                                                                    <th>Default</th>
                                                                    <th>Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {addon.addonValues?.map((value, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{value.value}</td>
                                                                        <td>{formatPrice(value.price)}</td>
                                                                        <td>
                                                                            {value.isDefault ? (
                                                                                <Badge bg="info">Default</Badge>
                                                                            ) : (
                                                                                <span className="text-muted">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <Badge bg={value.status === "ACTIVE" ? "success" : "secondary"}>
                                                                                {value.status}
                                                                            </Badge>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        ))}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowAllAddons(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* All Subscriptions Modal */}
                                <Modal
                                    show={showAllSubscriptions}
                                    onHide={() => setShowAllSubscriptions(false)}
                                    size="xl"
                                >
                                    <Modal.Header closeButton className="bg-light">
                                        <Modal.Title>
                                            <i className="bi bi-calendar-check me-2"></i>
                                            All Subscriptions
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="row">
                                            {eligibleSubscriptions.map((subscription, index) => (
                                                <div key={index} className="col-md-6 mb-4">
                                                    <Card className="h-100 border">
                                                        <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="fw-bold mb-0">{subscription.title}</h6>
                                                                <div className="text-muted small">{subscription.subTitle}</div>
                                                            </div>
                                                            {getSubscriptionStatusBadge(subscription.status)}
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <div className="row mb-3">
                                                                <div className="col-6">
                                                                    <div className="text-muted small">Price</div>
                                                                    <div className="fw-bold text-success h5 mb-0">{formatPrice(subscription.price)}</div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="text-muted small">Duration</div>
                                                                    <div className="fw-semibold h5 mb-0">{subscription.duration} days</div>
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="col-6">
                                                                    <div className="text-muted small">Type</div>
                                                                    {getSubscriptionTypeBadge(subscription.subscriptionType)}
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="text-muted small">Tax</div>
                                                                    <div className="fw-semibold">{subscription.taxPercent}%</div>
                                                                </div>
                                                            </div>

                                                            <div className="mb-3">
                                                                <div className="text-muted small mb-2">How it works:</div>
                                                                <ul className="small ps-3 mb-0">
                                                                    {subscription.subscriptionWorking?.map((item, i) => (
                                                                        <li key={i} className="mb-1">{item}</li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            ))}
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowAllSubscriptions(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Tab.Container>
                        ) : (
                            <div className="text-center py-5">
                                <div className="mb-3">
                                    <i className="bi bi-box-seam display-1 text-muted"></i>
                                </div>
                                <h5 className="fw-semibold mb-2">No Product Selected</h5>
                                <p className="text-muted mb-4">
                                    Please select a product from the dropdown above to view detailed information.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ProductDetailReport